// v2.19 — les jours couverts par un événement Google (« yyyy-MM-dd »), pour l'afficher chaque jour et pas que le premier.
import { format, parseISO, addDays, subMilliseconds, startOfDay } from 'date-fns';

export const eventDays = (evt) => {
  try {
    const start = startOfDay(parseISO(evt.datetime_start));
    const endRaw = evt.datetime_end ? parseISO(evt.datetime_end) : null;
    // la fin Google est exclue (toute la journée : le lendemain ; avec heure : l'instant de fin)
    const last = endRaw && endRaw > start ? startOfDay(subMilliseconds(endRaw, 1)) : start;
    const days = [];
    for (let d = start; d <= last && days.length < 400; d = addDays(d, 1)) days.push(format(d, 'yyyy-MM-dd'));
    return days;
  } catch { return []; }
};
